import type { UseQueryResult } from '@tanstack/react-query';
import type { AxiosError, AxiosResponse } from 'axios';
import type { z } from 'zod';

export const decodeHttpResponse = async <T extends z.ZodTypeAny>(
  schema: T,
  promise: Promise<AxiosResponse>,
): Promise<z.infer<T>> => {
  const { data } = await promise;
  try {
    return schema.parse(data);
  } catch (error) {
    // biome-ignore lint/suspicious/noConsole: for troubleshooting in production
    console.error('[ERROR] Failed to decode response: %s', error);
    throw error as AxiosError;
  }
};

const IGNORED_ERROR_CODE = [404];

export const isErrorIgnored = (
  item: UseQueryResult<unknown, AxiosError<{ code: number; message: string }> | null>,
) => {
  const errorCode = item.error?.response?.data.code;

  if (!item.isError) {
    return true;
  }
  return item.isError && errorCode && IGNORED_ERROR_CODE.includes(errorCode);
};
